
export default {
  name: 'Bucket',
  props: {
    image: {
      type: String,
      default: null
    },
    text: {
      type: String,
      default: null
    },
    url: {
      type: String,
      default: '#'
    }
  }
}
